import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const DriverDocuments = () => {
    const [title, setTitle] = useState("Agregar Documento de Conductor");
    const [loading, setLoading] = useState(false);
    const [driverDocumentId, setDriverDocumentId] = useState(0);
    const [driverId, setDriverId] = useState(0);
    const [curp, setCurp] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [medicalNumber, setMedicalNumber] = useState('');
    const [licenseNumber, setLicenseNumber] = useState('');
    const [address, setAddress] = useState('');
    const [licenseExpiration, setLicenseExpiration] = useState('');
    const [medicalCertificateExpiration, setMedicalCertificateExpiration] = useState('');
    
    // Estados para archivos
    const [licenseFiles, setLicenseFiles] = useState([]);
    const [medicalFiles, setMedicalFiles] = useState([]);
    const [otherFiles, setOtherFiles] = useState([]);
    
    const [documents, setDocuments] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [statusFilter, setStatusFilter] = useState(2);
    const [driverFilter, setDriverFilter] = useState(0);
    
    // Estadísticas
    const [active, setActive] = useState(0);
    const [expired, setExpired] = useState(0);
    const [expiring, setExpiring] = useState(0);
    
    // Estados para el modal de visualización
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [currentPdfUrl, setCurrentPdfUrl] = useState('');
    const [currentFileName, setCurrentFileName] = useState('');
    const [currentFiles, setCurrentFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);

    // Estado para el modal de detalle
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailDocument, setDetailDocument] = useState(null);

    // Estados para control de usuario
    const [currentUser, setCurrentUser] = useState(null);
    const [isUserInitialized, setIsUserInitialized] = useState(false);

    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        const initialize = async () => {
            await initializeUser();
        };
        
        initialize();
    }, []);

    // Efecto separado que se ejecuta cuando el usuario se inicializa
    useEffect(() => {
        if (isUserInitialized) {
            console.log('🔄 Usuario inicializado, cargando datos automáticamente...');
            loadData();
            getDrivers();
            
            setTimeout(() => {
                initializeSelect2();
            }, 100);
            
            // Initialize tooltips
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });
        }
    }, [isUserInitialized]);

    // Efecto para recargar cuando cambian los filtros
    useEffect(() => {
        if (isUserInitialized) {
            console.log('🔄 Filtros cambiados, recargando datos...');
            loadData();
        }
    }, [statusFilter, driverFilter]);

    const initializeSelect2 = () => {
        $('#driver_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#status_filter').select2({ width: "100%" });
        $('#driver_filter').select2({ width: "100%" });
    };

    // Función para inicializar el usuario
    const initializeUser = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("dataUser"));
            console.log('🔍 dataUser from localStorage:', userData);
            
            if (!userData || !userData.user_id) {
                throw new Error('No se encontró información de usuario en dataUser');
            }

            setCurrentUser(userData);
            setIsUserInitialized(true);
            console.log('✅ Current user set:', userData);
            console.log('🚗 Driver ID del usuario:', userData.driver_id);

        } catch (error) {
            console.error('Error initializing user:', error);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: 'Error al cargar la información del usuario: ' + error.message
            });
        }
    };

    // Función para verificar si es admin
    const isAdmin = () => {
        return currentUser?.rol_id === 1;
    };

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activos', value: 1 },
        { label: 'Próximos a vencer', value: 3 },
        { label: 'Vencidos', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#driver_filter').on("change", function (e) {
        setDriverFilter(e.target.value);
    });

    $('#driver_id').on("change", function (e) {
        setDriverId(e.target.value);
    });

    // Función para cargar datos (se usa tanto en inicialización como en filtros)
    const loadData = async () => {
        if (!isUserInitialized) {
            console.log('⏳ Esperando inicialización del usuario...');
            return;
        }

        setLoading(true);
        var table = $('.main').DataTable();
        if (table) table.destroy();
        
        const form = new FormData();
        form.append("status_filter", statusFilter);
        form.append("driver_filter", driverFilter);
        
        // Usar el driver_id del usuario actual
        const userDriverId = currentUser?.driver_id || 0;
        form.append("user_driver_id", userDriverId);
        
        console.log('📤 Enviando user_driver_id:', userDriverId);
        console.log('👤 Usuario actual:', currentUser);
        
        try {
            const response = await axios.post(ENDPOINT + "get-all-driver-documents", form);
            setDocuments(response.data.data);
            
            // Calcular estadísticas solo si es admin
            if (isAdmin()) {
                const today = new Date();
                const thirtyDaysFromNow = new Date();
                thirtyDaysFromNow.setDate(today.getDate() + 30);
                
                const activeDocs = response.data.data.filter(doc => doc.overall_badge === 'success');
                const expiringDocs = response.data.data.filter(doc => doc.overall_badge === 'warning');
                const expiredDocs = response.data.data.filter(doc => doc.overall_badge === 'danger');
                
                setActive(activeDocs.length);
                setExpiring(expiringDocs.length);
                setExpired(expiredDocs.length);
            }
            
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por nombre o CURP",
                    },
                });
                setLoading(false);
            }, 100);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    // Modificar la función getAll para que use loadData
    const getAll = () => {
        loadData();
    };

    const getDrivers = async () => {
        if (!isAdmin()) return; // Solo admin puede cargar la lista de conductores
        
        try {
            const response = await axios.get(ENDPOINT + 'get-all-drivers-simple');
            setDrivers(response.data.data);
        } catch (error) {
            console.error('Error cargando conductores:', error);
        }
    };

    // Manejar cambio de archivos
    const handleLicenseFilesChange = (e) => {
        setLicenseFiles(Array.from(e.target.files));
    };

    const handleMedicalFilesChange = (e) => {
        setMedicalFiles(Array.from(e.target.files));
    };

    const handleOtherFilesChange = (e) => {
        setOtherFiles(Array.from(e.target.files));
    };

    const calculateBirthdayInfo = (birthDate) => {
        if (!birthDate) return { age: '', badge: 'secondary' };
        
        const today = new Date();
        const birth = new Date(birthDate);
        const currentYear = today.getFullYear();
        
        // Calcular edad
        let age = currentYear - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        
        // Calcular próximo cumpleaños
        const nextBirthday = new Date(currentYear, birth.getMonth(), birth.getDate());
        if (today > nextBirthday) {
            nextBirthday.setFullYear(currentYear + 1);
        }
        
        const daysUntilBirthday = Math.ceil((nextBirthday - today) / (1000 * 60 * 60 * 24));
        
        // Determinar color según los días restantes
        let badge = 'primary'; // Azul por defecto (normal)
        if (daysUntilBirthday <= 1) {
            badge = 'purple'; // Morado para hoy o 1 día antes
        } else if (daysUntilBirthday <= 30) {
            badge = 'warning'; // Amarillo para próximo (30 días o menos)
        }
        
        return {
            age,
            daysUntilBirthday,
            badge,
            formattedDate: formatDate(birthDate)
        };
    };

    const handleReplaceFile = async (fileId, fileType, e) => {
        const file = e.target.files[0];
        if (!file) return;
        setLoading(true);
        const form = new FormData();
        form.append("file", file);
        form.append("file_type", fileType);
        try {
            const response = await axios.post(
                ENDPOINT + "replace-driver-file/" + fileId,
                form,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 2000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
            });
            setShowPdfModal(false);
            getAll();
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No se pudo reemplazar el archivo</div>',
            });
        }
        setLoading(false);
    };

    const handleNew = () => {
        clearField();
        $('#modal-default').modal('show');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        const form = new FormData();
        form.append("driver_id", driverId);
        form.append("curp", curp);
        form.append("birth_date", birthDate);
        form.append("medical_number", medicalNumber);
        form.append("license_number", licenseNumber);
        form.append("address", address);
        form.append("license_expiration", licenseExpiration);
        form.append("medical_certificate_expiration", medicalCertificateExpiration);

        // Agregar archivos
        licenseFiles.forEach(file => {
            form.append("license_files[]", file);
        });
        
        medicalFiles.forEach(file => {
            form.append("medical_files[]", file);
        });
        
        otherFiles.forEach(file => {
            form.append("other_files[]", file);
        });

        if (driverDocumentId === 0) {
            await axios
                .post(ENDPOINT + "save-driver-document", form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            await axios
                .post(ENDPOINT + "update-driver-document/" + driverDocumentId, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setDriverDocumentId(0);
        setDriverId(0);
        setCurp('');
        setBirthDate('');
        setMedicalNumber('');
        setLicenseNumber('');
        setAddress('');
        setLicenseExpiration('');
        setMedicalCertificateExpiration('');
        setLicenseFiles([]);
        setMedicalFiles([]);
        setOtherFiles([]);
        setTitle("Agregar Documento de Conductor");
        $('#driver_id').val('0').trigger('change');
        $('#driver_id').select2('destroy');
        setTimeout(() => {
            initializeSelect2();
        }, 100);
        
        // Limpiar inputs de archivos
        document.getElementById('license_files').value = '';
        document.getElementById('medical_files').value = '';
        document.getElementById('other_files').value = '';
    };

    const handleViewPdf = async (files, index = 0) => {
        console.log('handleViewPdf', files, index);
        if (!files || files.length === 0) {
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No hay archivos para mostrar</div>',
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
            return;
        }
        
        setLoading(true);
        const file = files[index];
        try {
            const response = await axios.get(ENDPOINT + "get-driver-file-url/" + file.file_id);
            if (response.data.res) {
                setCurrentFiles(files);
                setCurrentFileIndex(index);
                setCurrentPdfUrl(response.data.data.file_url);
                setCurrentFileName(response.data.data.file_name);
                setShowPdfModal(true);
                console.log('PDF URL:', response.data.data.file_url);
            } else {
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            }
        } catch (error) {
            console.error('Error loading file:', error);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al cargar el archivo: ' + error.message + '</div>',
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }
        setLoading(false);
    };

    // Navegación entre archivos
    const handlePrevFile = async () => {
        if (currentFileIndex > 0) {
            await handleViewPdf(currentFiles, currentFileIndex - 1);
        }
    };

    const handleNextFile = async () => {
        if (currentFileIndex < currentFiles.length - 1) {
            await handleViewPdf(currentFiles, currentFileIndex + 1);
        }
    };

    const closePdfModal = () => {
        setShowPdfModal(false);
        setCurrentPdfUrl('');
        setCurrentFileName('');
        setCurrentFiles([]);
        setCurrentFileIndex(0);
    };

    const handleDownloadFile = async (fileId, fileName) => {
        try {
            setLoading(true);
            const response = await axios.get(ENDPOINT + "download-driver-file/" + fileId, {
                responseType: 'blob'
            });
            
            // Crear URL para descarga
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            setLoading(false);
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al descargar el archivo: ' + error.message + '</div>',
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }
    };

    const handleDeleteFile = async (fileId) => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                await axios
                    .get(ENDPOINT + "delete-driver-file/" + fileId)
                    .then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-driver-document-detail/" + id)
            .then((response) => {
                const data = response.data.data;
                setDriverDocumentId(data.driver_document_id);
                setDriverId(data.driver_id);
                setCurp(data.curp);
                setBirthDate(data.birth_date);
                setMedicalNumber(data.medical_number);
                setLicenseNumber(data.license_number);
                setAddress(data.address);
                setLicenseExpiration(data.license_expiration);
                setMedicalCertificateExpiration(data.medical_certificate_expiration);
                setTitle("Editar Documento de Conductor");
                $('#driver_id').val(data.driver_id).trigger('change');
                setLoading(false);
                $('#modal-default').modal('show');
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡No podrás revertir esto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                await axios
                    .get(ENDPOINT + "delete-driver-document/" + id)
                    .then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const handleViewDetail = async (id) => {
        setLoading(true);
        try {
            const response = await axios.get(ENDPOINT + "get-driver-document-detail/" + id);
            setDetailDocument(response.data.data);
            setShowDetailModal(true);
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No se pudo cargar el detalle</div>',
            });
        }
        setLoading(false);
    };

    function formatDate(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date)) return dateStr;
        return date.toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }

    return (
        <>
            <style>
                {`
                .badge-success {
                    background-color: #28a745 !important;
                    color: #fff !important;
                }
                .badge-warning {
                    background-color: #ffc107 !important;
                    color: #212529 !important;
                }
                .badge-danger {
                    background-color: #dc3545 !important;
                    color: #fff !important;
                }
                .badge-purple {
                    background-color: #6f42c1 !important;
                    color: #fff !important;
                }
                .badge-primary {
                    background-color: #007bff !important;
                    color: #fff !important;
                }
                `}
            </style>

            <div className="content-wrapper">
                <ContentHeader title="Documentos de Conductores" />
                
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h3 className="card-title">Listado de Documentos</h3>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                {/* Solo mostrar botón Agregar si es admin */}
                                                {isAdmin() && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#modal-default"
                                                        id="openmodal"
                                                        onClick={handleNew}
                                                    >
                                                        <i className="fa fa-plus"></i> Agregar
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Filtros - Solo mostrar si es admin */}
                                    {isAdmin() && (
                                        <div className="card-body">
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <label>Filtrar por Estado:</label>
                                                    <select
                                                        className="form-control select2"
                                                        id="status_filter"
                                                        value={statusFilter}
                                                        onChange={(e) => setStatusFilter(e.target.value)}
                                                    >
                                                        {selectStatus.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <label>Filtrar por Conductor:</label>
                                                    <select
                                                        className="form-control select2"
                                                        id="driver_filter"
                                                        value={driverFilter}
                                                        onChange={(e) => setDriverFilter(e.target.value)}
                                                    >
                                                        <option value="0">Todos los conductores</option>
                                                        {drivers.map((driver) => (
                                                            <option key={driver.value} value={driver.value}>
                                                                {driver.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <label>&nbsp;</label>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-block"
                                                        onClick={loadData}
                                                    >
                                                        <i className="fa fa-refresh"></i> Actualizar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Estadísticas - Solo mostrar si es admin */}
                                    {isAdmin() && (
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <div className="info-box bg-success">
                                                    <span className="info-box-icon">
                                                        <i className="fa fa-check-circle"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text">Activos</span>
                                                        <span className="info-box-number">{active}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-box bg-warning">
                                                    <span className="info-box-icon">
                                                        <i className="fa fa-exclamation-triangle"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text">Por Vencer</span>
                                                        <span className="info-box-number">{expiring}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-box bg-danger">
                                                    <span className="info-box-icon">
                                                        <i className="fa fa-times-circle"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text">Vencidos</span>
                                                        <span className="info-box-number">{expired}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Tabla */}
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped main">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Conductor</th>
                                                    <th>CURP</th>
                                                    <th>Cumpleaños</th>
                                                    <th>No. Licencia</th>
                                                    <th>No. Médico</th>
                                                    <th>Vencimiento Licencia</th>
                                                    <th>Vencimiento Cert. Médico</th>
                                                    <th>Estado General</th>
                                                    <th>Archivos</th>
                                                    {/* Ocultar columna Acciones si no es admin */}
                                                    {isAdmin() && <th>Acciones</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.map((document, index) => {
                                                    const birthdayInfo = calculateBirthdayInfo(document.birth_date);
                                                    
                                                    return (
                                                        <tr key={document.driver_document_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{document.driver?.name} {document.driver?.last_name}</td>
                                                            <td>{document.curp}</td>
                                                            <td>
                                                                <span 
                                                                    className={`badge badge-${birthdayInfo.badge}`}
                                                                    data-bs-toggle="tooltip" 
                                                                    title={`${birthdayInfo.daysUntilBirthday} días restantes`}
                                                                >
                                                                    {birthdayInfo.formattedDate} - {birthdayInfo.age} años
                                                                </span>
                                                            </td>
                                                            <td>{document.license_number}</td>
                                                            <td>{document.medical_number}</td>
                                                            <td>
                                                                <span className={`badge badge-${document.license_badge}`}>
                                                                    {formatDate(document.license_expiration)} - {document.license_status}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className={`badge badge-${document.medical_badge}`}>
                                                                    {formatDate(document.medical_certificate_expiration)} - {document.medical_status}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className={`badge badge-${document.overall_badge}`}>
                                                                    {document.overall_status}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {document.files && document.files.length > 0 ? (
                                                                    <div className="dropdown">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info btn-sm"
                                                                            onClick={() => handleViewPdf(document.files, 0)}
                                                                            data-bs-toggle="tooltip"
                                                                            title="Ver archivos"
                                                                        >
                                                                            <i className="fa fa-eye"></i> Ver ({document.files.length})
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info btn-sm dropdown-toggle dropdown-toggle-split"
                                                                            data-toggle="dropdown"
                                                                            aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            tabIndex="-1"
                                                                        >
                                                                            <span className="sr-only">Toggle Dropdown</span>
                                                                        </button>
                                                                        <div className="dropdown-menu">
                                                                            {document.files.map((file, fileIndex) => (
                                                                                <div key={file.file_id} className="dropdown-item d-flex justify-content-between align-items-center">
                                                                                    <span className="text-truncate" style={{maxWidth: '150px'}} title={file.file_original_name}>
                                                                                        {file.file_original_name}
                                                                                    </span>
                                                                                    <div className="btn-group ml-2">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success btn-xs"
                                                                                            onClick={e => {
                                                                                                e.preventDefault();
                                                                                                e.stopPropagation();
                                                                                                handleViewPdf(document.files, fileIndex);
                                                                                            }}
                                                                                            data-bs-toggle="tooltip"
                                                                                            title="Ver archivo"
                                                                                        >
                                                                                            <i className="fa fa-eye"></i>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary btn-xs"
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e.stopPropagation();
                                                                                                handleDownloadFile(file.file_id, file.file_original_name);
                                                                                            }}
                                                                                            data-bs-toggle="tooltip"
                                                                                            title="Descargar"
                                                                                        >
                                                                                            <i className="fa fa-download"></i>
                                                                                        </button>
                                                                                        {isAdmin() && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-danger btn-xs"
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    e.stopPropagation();
                                                                                                    handleDeleteFile(file.file_id);
                                                                                                }}
                                                                                                data-bs-toggle="tooltip"
                                                                                                title="Eliminar"
                                                                                            >
                                                                                                <i className="fa fa-trash"></i>
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <span className="badge badge-secondary">Sin archivos</span>
                                                                )}
                                                            </td>
                                                            {/* Mostrar acciones solo si es admin */}
                                                            {isAdmin() && (
                                                                <td>
                                                                    <div className="btn-group">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info btn-sm"
                                                                            onClick={() => handleViewDetail(document.driver_document_id)}
                                                                            data-bs-toggle="tooltip"
                                                                            title="Ver Detalle"
                                                                        >
                                                                            <i className="fa fa-search"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-warning btn-sm"
                                                                            onClick={() => handleEdit(document.driver_document_id)}
                                                                            data-bs-toggle="tooltip"
                                                                            title="Editar"
                                                                        >
                                                                            <i className="fa fa-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => handleDelete(document.driver_document_id)}
                                                                            data-bs-toggle="tooltip"
                                                                            title="Eliminar"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Modal para agregar/editar - Solo disponible para admin */}
                {isAdmin() && (
                    <div className="modal fade" id="modal-default">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">{title}</h4>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form id="form" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Conductor *</label>
                                                    <select
                                                        className="form-control select2"
                                                        id="driver_id"
                                                        value={driverId}
                                                        onChange={(e) => setDriverId(e.target.value)}
                                                        required
                                                    >
                                                        <option value="0">Seleccionar conductor</option>
                                                        {drivers.map((driver) => (
                                                            <option key={driver.value} value={driver.value}>
                                                                {driver.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>CURP *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingrese CURP"
                                                        value={curp}
                                                        onChange={(e) => setCurp(e.target.value)}
                                                        required
                                                        maxLength="18"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha de Nacimiento *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={birthDate}
                                                        onChange={(e) => setBirthDate(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Número Médico *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingrese número médico"
                                                        value={medicalNumber}
                                                        onChange={(e) => setMedicalNumber(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Número de Licencia *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingrese número de licencia"
                                                        value={licenseNumber}
                                                        onChange={(e) => setLicenseNumber(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Domicilio *</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Ingrese domicilio"
                                                        value={address}
                                                        onChange={(e) => setAddress(e.target.value)}
                                                        required
                                                        rows="3"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Vencimiento Licencia *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={licenseExpiration}
                                                        onChange={(e) => setLicenseExpiration(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Vencimiento Cert. Médico *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={medicalCertificateExpiration}
                                                        onChange={(e) => setMedicalCertificateExpiration(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Sección de archivos */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Archivos de Licencia *</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="license_files"
                                                        onChange={handleLicenseFilesChange}
                                                        multiple
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        required={driverDocumentId === 0}
                                                    />
                                                    <small className="form-text text-muted">
                                                        Formatos permitidos: PDF, JPG, JPEG, PNG (Máx. 5MB por archivo)
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Archivos de Cert. Médico *</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="medical_files"
                                                        onChange={handleMedicalFilesChange}
                                                        multiple
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        required={driverDocumentId === 0}
                                                    />
                                                    <small className="form-text text-muted">
                                                        Formatos permitidos: PDF, JPG, JPEG, PNG (Máx. 5MB por archivo)
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Otros Archivos</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        id="other_files"
                                                        onChange={handleOtherFilesChange}
                                                        multiple
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                    />
                                                    <small className="form-text text-muted">
                                                        Formatos permitidos: PDF, JPG, JPEG, PNG (Máx. 5MB por archivo)
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Vista previa de archivos seleccionados */}
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h5 className="card-title">Archivos Seleccionados</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <strong>Licencias:</strong>
                                                                <ul className="list-unstyled">
                                                                    {licenseFiles.map((file, index) => (
                                                                        <li key={index} className="text-truncate">
                                                                            <small>{file.name}</small>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <strong>Cert. Médicos:</strong>
                                                                <ul className="list-unstyled">
                                                                    {medicalFiles.map((file, index) => (
                                                                        <li key={index} className="text-truncate">
                                                                            <small>{file.name}</small>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <strong>Otros:</strong>
                                                                <ul className="list-unstyled">
                                                                    {otherFiles.map((file, index) => (
                                                                        <li key={index} className="text-truncate">
                                                                            <small>{file.name}</small>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        id="closemodal"
                                        onClick={() => $('#modal-default').modal('hide')}
                                    >
                                        Cerrar
                                    </button>
                                    <button
                                        type="submit"
                                        form="form"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span>
                                                <i className="fa fa-spinner fa-spin"></i> Procesando...
                                            </span>
                                        ) : (
                                            <span>
                                                <i className="fa fa-save"></i> Guardar
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showPdfModal && (
                    <div className="modal fade show d-block" id="pdfModal" tabIndex="-1"
                        aria-labelledby="pdfModalLabel"
                        style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '95%', height: '90vh' }}>
                            <div className="modal-content h-100">
                                <div className="modal-header bg-primary text-white">
                                    <h5 className="modal-title" id="pdfModalLabel">
                                        <i className="fas fa-file-pdf me-2"></i>
                                        Visualizando: {currentFileName}
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={closePdfModal}></button>
                                </div>
                                <div className="modal-body p-0" style={{ height: 'calc(100% - 120px)' }}>
                                    {currentPdfUrl ? (
                                        <iframe
                                            id="pdf-viewer-iframe"
                                            src={currentPdfUrl}
                                            width="100%"
                                            height="100%"
                                            frameBorder="0"
                                            title={`PDF Viewer - ${currentFileName}`}
                                            style={{ border: 'none' }}
                                        />
                                    ) : (
                                        <div className="d-flex justify-content-center align-items-center h-100">
                                            <div className="text-center">
                                                <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                                                <p>Cargando PDF...</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer d-flex flex-wrap gap-2">
                                    {isAdmin() && (
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteFile(currentFiles[currentFileIndex].file_id)}
                                            >
                                                <i className="fas fa-trash me-1"></i> Eliminar archivo
                                            </button>
                                            <label className="btn btn-warning mb-0">
                                                <i className="fas fa-sync-alt me-1"></i> Reemplazar archivo
                                                <input
                                                    type="file"
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    style={{ display: "none" }}
                                                    onChange={e =>
                                                        handleReplaceFile(
                                                            currentFiles[currentFileIndex].file_id,
                                                            currentFiles[currentFileIndex].file_type,
                                                            e
                                                        )
                                                    }
                                                />
                                            </label>
                                        </>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={closePdfModal}
                                    >
                                        <i className="fas fa-times me-1"></i> Cerrar
                                    </button>
                                    <a
                                        href={currentPdfUrl}
                                        className="btn btn-success"
                                        download={currentFileName}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fas fa-download me-1"></i> Descargar
                                    </a>
                                    {currentFiles.length > 1 && (
                                        <>
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={handlePrevFile}
                                                disabled={currentFileIndex === 0}
                                            >
                                                <i className="fa fa-arrow-left"></i> Anterior
                                            </button>
                                            <span className="mx-2 align-self-center">
                                                {currentFileIndex + 1} / {currentFiles.length}
                                            </span>
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={handleNextFile}
                                                disabled={currentFileIndex === currentFiles.length - 1}
                                            >
                                                Siguiente <i className="fa fa-arrow-right"></i>
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showDetailModal && detailDocument && (
                    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        <i className="fa fa-id-card me-2"></i>
                                        Detalle del Documento de Conductor
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowDetailModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <dl className="row">
                                        <dt className="col-sm-4">Conductor</dt>
                                        <dd className="col-sm-8">{detailDocument.driver?.name} {detailDocument.driver?.last_name}</dd>
                                        <dt className="col-sm-4">CURP</dt>
                                        <dd className="col-sm-8">{detailDocument.curp}</dd>
                                        <dt className="col-sm-4">Fecha de Nacimiento</dt>
                                        <dd className="col-sm-8">{formatDate(detailDocument.birth_date)}</dd>
                                        <dt className="col-sm-4">Número Médico</dt>
                                        <dd className="col-sm-8">{detailDocument.medical_number}</dd>
                                        <dt className="col-sm-4">Número de Licencia</dt>
                                        <dd className="col-sm-8">{detailDocument.license_number}</dd>
                                        <dt className="col-sm-4">Domicilio</dt>
                                        <dd className="col-sm-8">{detailDocument.address}</dd>
                                        <dt className="col-sm-4">Vencimiento Licencia</dt>
                                        <dd className="col-sm-8">{formatDate(detailDocument.license_expiration)}</dd>
                                        <dt className="col-sm-4">Vencimiento Cert. Médico</dt>
                                        <dd className="col-sm-8">{formatDate(detailDocument.medical_certificate_expiration)}</dd>
                                        <dt className="col-sm-4">Estado General</dt>
                                        <dd className="col-sm-8">
                                            <span className={`badge badge-${detailDocument.overall_badge}`}>
                                                {detailDocument.overall_status}
                                            </span>
                                        </dd>
                                        <dt className="col-sm-4">Archivos</dt>
                                        <dd className="col-sm-8">
                                            {detailDocument.files && detailDocument.files.length > 0 ? (
                                                <ul>
                                                    {detailDocument.files.map(file => (
                                                        <li key={file.file_id}>
                                                            {file.file_original_name}
                                                            <button
                                                                className="btn btn-link btn-sm"
                                                                onClick={() => handleDownloadFile(file.file_id, file.file_original_name)}
                                                            >
                                                                <i className="fa fa-download"></i>
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <span className="badge badge-secondary">Sin archivos</span>
                                            )}
                                        </dd>
                                    </dl>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {loading && <Loader />}
            </div>
        </>
    );
};

export default DriverDocuments;